export default __webpack_public_path__ + "static/media/trade-mobile.c01d82ed.png";